import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAK4JBIWv45Oqb8yN__Rcf-tYXAgDeN-qo",
  authDomain: "rogueai.firebaseapp.com",
  projectId: "rogueai",
  storageBucket: "rogueai.appspot.com",
  messagingSenderId: "276435013800",
  appId: "1:276435013800:web:248d67377e7faeeec5329d",
  measurementId: "G-GXSDS78EPJ",
};
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  var functions = firebase.functions();
  var storage = firebase.storage();
}

export { firebase, functions, storage };
